export default __webpack_public_path__ + "static/media/d2ff14c84a3aedad.87d7d751a796819df67841d2df4590ce.svg";